import React, { Component } from 'react';
import { Big3Common } from '../../../js/IncludeManager'

/* 개발담당:양유빈
 * 화면기능:클로디공지 상세
 * 세부설명:
*/

export class ClodMsgDtl extends Component {
    static displayName = ClodMsgDtl.name;

    constructor(props) {
        super(props);
        this.state = {
        };
        this.handleMsg_Click = this.handleMsg_Click.bind(this);
    }
    //초기화
    componentDidMount() {
        if (this.props.ContentState !== null) {
            let Notino = this.props.ContentState.Notino;
            let Noti_Idx = this.props.ContentState.Noti_Idx;
            let WUid = this.props.ContentState.WUid;
            this.CallClodMsgDtlData(Notino, Noti_Idx, WUid)
        }
    }
    //목록이동
    handleMsg_Click(event) {
        this.props.RenderComponent("ClodMsg", this.props.ContentState);
        event.preventDefault();
    }
    //공지 상세내역 조회
    NoticeData = [];
    async CallClodMsgDtlData(Notino, Noti_Idx, WUid) {
        try {
            let Paging = { notino: Notino, noti_idx: Noti_Idx, wuid: WUid }
            let Data = await Big3Common.Post('api/MyPage/Notice/GetNoticeMgtDtl', Paging);

            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.NoticeData = JSON.parse(Data.dataTable);
                this.forceUpdate();
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallClodMsgDtlData: ", e)
        }
        return false;
    }
    render() {
        let noticedata = this.NoticeData;

        let noti_title = "";
        let reg_dt = "";
        let noti_contt = "";
        if (noticedata.length > 0) {
            noti_title = noticedata[0].noti_title;
            reg_dt = noticedata[0].reg_dt;
            noti_contt = noticedata[0].noti_contt;
        }
        return (
            <div className="p_b_margin container_box d_padding">
                <div className="notice_dtl_title">
                    {noti_title}
                </div>
                <div className="noctice_dtl_day">
                    {reg_dt}
                </div>
                <div className="notice_dtl_txt" style={{ whiteSpace: 'pre-line' }}>
                    {noti_contt}
                </div>
                <div className="button_line_s">
                    <button type="button" className="btn_v btn_v1 " onClick={this.handleMsg_Click}>확인</button>
                </div>
            </div>
        );
    }
}
